import React, { useContext } from 'react';
import AppContext from '../../AppContext';
// import styled from "styled-components"

const Q4BizEmbedding = (props) => {
    
  // const [loading, setLoading] = useState(true);
  const { qUrl, showWlsLogo } = useContext(AppContext);

  return <div className={'flex flex-1 h-full'} >
    <iframe className='w-full' src={qUrl}/>
    {showWlsLogo && <div style={{position: 'absolute', bottom: 0, right: 0}}>
      <a href='https://www.westloop.io' alt='Westloop Strategy Home'>
        <img src='/wls_logo.svg' className='logo'/>
      </a>
    </div>}
  </div>;
}

export default Q4BizEmbedding;